(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("simple-json-api-resource-seralizer", [], factory);
	else if(typeof exports === 'object')
		exports["simple-json-api-resource-seralizer"] = factory();
	else
		root["simple-json-api-resource-seralizer"] = factory();
})(window, function() {
return 